
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3C0 1.34315 1.34315 0 3 0H22C23.6569 0 25 1.34315 25 3V22C25 23.6569 23.6569 25 22 25H3C1.34315 25 0 23.6569 0 22V3Z","fill":"#F9A13E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.3333 19.8672C14.9552 19.0024 12.3764 18.8505 9.91316 19.4301L6.89552 20.1401C6.35792 20.2666 5.81956 19.9333 5.69307 19.3957C5.56657 18.8581 5.89984 18.3197 6.43745 18.1932L9.45508 17.4832C12.2973 16.8145 15.2728 16.9898 18.0168 17.9876L18.6749 18.2269C19.1939 18.4156 19.4617 18.9894 19.2729 19.5084C19.0842 20.0274 18.5104 20.2952 17.9914 20.1065L17.3333 19.8672Z","fill":"#A96E2B"}}),_c('path',{attrs:{"d":"M9.16683 7.50001C9.16683 8.42048 8.42064 9.16668 7.50016 9.16668C6.57969 9.16668 5.8335 8.42048 5.8335 7.50001C5.8335 6.57954 6.57969 5.83334 7.50016 5.83334C8.42064 5.83334 9.16683 6.57954 9.16683 7.50001Z","fill":"#A96E2B"}}),_c('path',{attrs:{"d":"M19.1668 7.50001C19.1668 8.42048 18.4206 9.16668 17.5002 9.16668C16.5797 9.16668 15.8335 8.42048 15.8335 7.50001C15.8335 6.57954 16.5797 5.83334 17.5002 5.83334C18.4206 5.83334 19.1668 6.57954 19.1668 7.50001Z","fill":"#A96E2B"}})])
          )
        }
      }
    